import Header from '../components/Header'
import { useEffect, useState } from 'react'
import classNames from 'classnames'
import GlobalState, { setLang, watchVideo } from '../stores/GlobalState'
import { observer } from 'mobx-react'
import ContentState, {
  getAcDocsContent,
  getBusinessContent,
  getCities,
  getClearanceContent,
  getCoopContent,
  getFaqContent,
  getFooter,
  getMenu,
  getServicesContent,
  getSubMenu,
  getTariffsContent,
  getTerminals,
  getTerminalsContent,
  getThingsContent,
} from '../stores/ContentState'
import Menu from '../components/Menu'
import LocaleMenu from '../components/LocaleMenu'
import Cookie from '../components/common/Cookie'
import ThingsContent from '../components/pages/things/ThingsContent'
import Footer from '../components/Footer'
import { ReactComponent as Arrow } from '../assets/arrow-left.svg'
import { useLocation, useParams } from 'react-router'
import { runInAction } from 'mobx'
import { CountriesStore } from '../components/pages/career/CoopPop'
import Coop from '../components/common/CoopPop'
import VideoBox from '../components/VideoBox'
import changeLocaleByPath from '../mocks/changeLocale'
import SingleProduct from '../components/pages/singleprod/SingleProduct'

const ThingsPage = observer(() => {
  const [loading, setLoading] = useState(true)
  const [showFooter, setFooter] = useState(false)
  const { pathname } = useLocation()
  const { params } = useParams()

  useEffect(() => {
    changeLocaleByPath(pathname)
    setLang()
    getMenu().then(() => {})
    getSubMenu()
    getFooter()
    getCoopContent()

    return () => {
      setLoading(true)
    }
  }, [])

  const getCountries = async () => {
    const fd = new FormData()
    fd.append('lang', GlobalState.currentLocale.lang)
    fd.append('status', 'search-flag')

    fetch(GlobalState.domain, {
      method: 'POST',
      body: fd,
    })
      .then((response) => response.json())
      .then(
        (result) => {
          runInAction(() => {
            CountriesStore.list = result
          })
        },
        (e) => {
          console.log(e)
        },
      )
  }

  useEffect(() => {
    if (!pathname.includes('offices')) {
      getThingsContent().then(() => {
        setTimeout(() => {
          setLoading(false)
        }, 200)
      })
    }
  }, [])

  useEffect(() => {
    let path = '/for-you/'
    path = GlobalState.currentLocale.lang.includes('En')
      ? '/en' + path
      : GlobalState.currentLocale.lang.includes('ру')
      ? '/ru' + path
      : path

    let lang = GlobalState.currentLocale.lang.includes('En')
      ? '/en'
      : GlobalState.currentLocale.lang.includes('ру')
      ? '/ru'
      : ''
    switch (pathname) {
      case `${path}`:
        if (window.innerWidth <= 900) {
          document.querySelector('#root')?.classList.remove('hidden-menu')
          document.querySelector('html')?.classList.remove('hidden-menu')
          document.querySelector('body')?.classList.remove('hidden-menu')
        }
        getThingsContent().then(() => {
          setTimeout(() => {
            setLoading(false)
          }, 200)
        })
        break
      case `${lang}/offices/`:
        if (document.referrer.includes('for-you')) {
          getThingsContent()
        } else if (document.referrer.includes('for-business')) {
          getBusinessContent()
        } else getThingsContent()

        getTerminalsContent().then(() => {
          setTimeout(() => {
            setLoading(false)
          }, 200)
        })

        getCities()
        break
      case `${path}services/`:
        if (window.innerWidth > 900) {
          document.querySelector('#root')?.classList.remove('hidden-menu')
          document.querySelector('html')?.classList.remove('hidden-menu')
          document.querySelector('body')?.classList.remove('hidden-menu')
        }
        getServicesContent().then(() => {
          setTimeout(() => {
            setLoading(false)
          }, 200)
        })
        break
      case `${path}tariffs/`:
        if (window.innerWidth <= 900) {
          document.querySelector('#root')?.classList.add('hidden-menu')
          document.querySelector('html')?.classList.add('hidden-menu')
          document.querySelector('body')?.classList.add('hidden-menu')
        }
        getTariffsContent().then(() => {
          setTimeout(() => {
            setLoading(false)
          }, 200)
        })
        getCountries()

        break
      case `${path}customs-clearance/`:
        getClearanceContent().then(() => {
          setTimeout(() => {
            setLoading(false)
          }, 200)
        })
        break
      case `${path}accompanying-documents/`:
        getAcDocsContent().then(() => {
          setTimeout(() => {
            setLoading(false)
          }, 200)
        })
        break
      case `${path}faq/`:
        getFaqContent().then(() => {
          setTimeout(() => {
            setLoading(false)
          }, 200)
        })
        break
    }

    return () => {
      setLoading(true)
    }
  }, [pathname])

  useEffect(() => {
    if (params) {
      getThingsContent().then(() => {
        setLoading(false)
      })
    }
    return () => {
      setLoading(true)
    }
  }, [params])

  useEffect(() => {
    if (loading) return
    document.querySelector('#root')?.classList.add('visible')
    document.querySelector('#root')?.classList.add('auto')
    document.querySelector('html')?.classList.add('auto')
    document.querySelector('body')?.classList.add('auto')
    document.querySelector('#root')?.classList.add('overflow-visible')
    document.querySelector('html')?.classList.add('overflow-visible')
    document.querySelector('body')?.classList.add('overflow-visible')
    document.querySelector('.header')?.classList.remove('light')
    document.querySelector('.navigation')?.classList.remove('light')
    ;(document.querySelector('.button.chat') as HTMLElement)?.classList.add(
      'contact',
    )
    document.querySelector('#root')?.classList.add('products')

    if (window.innerWidth <= 768) {
      ;(document.querySelector(
        '.button.chat',
      ) as HTMLElement)?.style.setProperty('visibility', 'hidden')
    }
    return () => {
      document.querySelector('#root')?.classList.remove('visible')
    }
  }, [loading])

  useEffect(() => {
    setTimeout(() => {
      window.addEventListener('scroll', (e) => {
        const header = document.querySelector('.header')

        if (!header) return
        if (window.scrollY > header?.getBoundingClientRect().height / 4) {
          header.classList.add('header-hidden')
        } else header.classList.remove('header-hidden')
      })
    }, 100)
  }, [])

  useEffect(() => {
    window.addEventListener('keydown', function (event: any) {
      if (
        event.ctrlKey == true &&
        (event.which == '61' ||
          event.which == '107' ||
          event.which == '173' ||
          event.which == '109' ||
          event.which == '187' ||
          event.which == '189')
      ) {
        event.preventDefault()
      }

      if (
        event.which != '86' &&
        event.which != '67' &&
        event.metaKey &&
        event.which != 65
      ) {
        event.preventDefault()
      }
    })

    window.addEventListener('mousewheel DOMMouseScroll', function (event: any) {
      if (event.ctrlKey == true) {
        event.preventDefault()
      }
    })
  }, [])

  useEffect(() => {
    if (GlobalState.isCoopShow) {
      document.querySelector('body, html, #root')?.classList.add('hidden-menu')
    } else
      document
        .querySelector('body, html, #root')
        ?.classList.remove('hidden-menu')
  }, [GlobalState.isCoopShow])

  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])

  useEffect(() => {
    if (!loading) {
      if (window.location.href.includes('#')) {
        const par = window.location.hash

        const elem = document.querySelector(`${par}`)

        if (!elem) return

        const top = elem!.getBoundingClientRect().top,
          bodyTop = document.body.getBoundingClientRect().top
        const offset = top - bodyTop

        window?.scrollTo({
          top: offset - 50,
          behavior: 'smooth',
        })
      }
    }
  }, [loading, pathname])

  useEffect(() => {
    setTimeout(() => {
      setFooter(true)
    }, 2000)

    return () => {
      setFooter(false)
    }
  }, [])

  let path = '/for-you/'
  path = GlobalState.currentLocale.lang.includes('En')
    ? '/en' + path
    : GlobalState.currentLocale.lang.includes('ру')
    ? '/ru' + path
    : path

  let lang = GlobalState.currentLocale.lang.includes('En')
    ? '/en'
    : GlobalState.currentLocale.lang.includes('ру')
    ? '/ru'
    : ''

  return (
    <>
      <Header />
      <Cookie />
      {!loading && (
        <div
          className={classNames(
            'container smooth-scroll',
            loading && 'hidden',
            !loading && 'visible',
            GlobalState.isLocaleOpen && 'overflow',
            GlobalState.isMenuOpen && 'overflow',
          )}
        >
          {!params ? (
            <ThingsContent
              menu={ContentState.things?.menu || []}
              blocks={ContentState.things?.blocks || []}
              banners={ContentState.things?.banners || []}
              content={
                pathname == path
                  ? ContentState.things
                  : pathname == `${path}services/`
                  ? ContentState.services
                  : pathname == `${path}customs-clearance/`
                  ? ContentState.clearance
                  : pathname == `${path}accompanying-documents/`
                  ? ContentState.acdocs
                  : pathname == `${path}faq/`
                  ? ContentState.faq
                  : pathname == `${lang}/offices/`
                  ? ContentState.terminals
                  : ContentState.tariffs
              }
            />
          ) : (
            <SingleProduct
              blocks={ContentState.things?.blocks || []}
              menu={ContentState.things?.menu || []}
              banners={ContentState.things?.banners || []}
            />
          )}
          {showFooter && <Footer />}
        </div>
      )}
      {!loading && (
        <>
          <Menu />
          <LocaleMenu />
          {width > 480 && (
            <div
              className="team__bottom-arrow"
              onClick={() => {
                window.scrollTo(0, 0)
              }}
            >
              <Arrow />
            </div>
          )}
        </>
      )}
      <VideoBox
        src={GlobalState.video.src}
        poster={GlobalState.video.poster}
        setShow={() =>
          watchVideo(GlobalState.video.src, GlobalState.video.poster)
        }
      />
      {GlobalState.isCoopShow && <Coop />}
      <div
        className={classNames('menu__bg', GlobalState.isMenuOpen && 'show')}
      ></div>
      <div
        className={classNames('menu__bg', GlobalState.isLocaleOpen && 'show')}
      ></div>
    </>
  )
})

export default ThingsPage
